/**
 * 商品ページ メディアギャラリー — Swiper.js（メイン画像のみ）
 * サムネイルは CSS Grid（7列・折り返し）
 */
(function () {
  const ROOT_SELECTOR = '[data-yamaga-swiper-gallery]';

  function getViewer(gallery) {
    return gallery.querySelector('[id^="GalleryViewer"]');
  }

  function getMainSlides(gallery) {
    return gallery.querySelectorAll('.yamaga-product-gallery__main .swiper-slide[data-media-id]');
  }

  function getThumbs(gallery) {
    return gallery.querySelectorAll('.yamaga-product-gallery__thumb');
  }

  function getSlideImageAlt(slide) {
    if (!slide) return '';

    const dataAlt = slide.getAttribute('data-media-alt');
    if (dataAlt !== null) return dataAlt.trim();

    return slide.querySelector('.product__modal-opener--image .media img, .media img')?.getAttribute('alt')?.trim() || '';
  }

  function syncCaption(gallery, activeIndex) {
    const caption = gallery.querySelector('.yamaga-product-gallery__caption');
    if (!caption) return;

    const slides = gallery.querySelectorAll(
      '.yamaga-product-gallery__main .swiper-slide[data-media-id], .yamaga-product-gallery__viewer .product__media-item[data-media-id]'
    );
    const slide = slides[activeIndex];
    const alt = slide ? getSlideImageAlt(slide) : '';

    caption.textContent = alt;
    caption.hidden = !alt;
  }

  function syncActiveClasses(gallery, activeIndex) {
    const slides = getMainSlides(gallery);
    slides.forEach((slide, index) => {
      const isActive = index === activeIndex;
      // Dawn の display:none 回避 — メインスライドは常に is-active を維持
      slide.classList.add('is-active');
      slide.classList.toggle('yamaga-product-gallery__slide--current', isActive);
    });

    getThumbs(gallery).forEach((thumb, index) => {
      const isActive = index === activeIndex;
      thumb.classList.toggle('yamaga-product-gallery__thumb--active', isActive);
      const button = thumb.querySelector('button');
      if (!button) return;
      if (isActive) {
        button.setAttribute('aria-current', 'true');
      } else {
        button.removeAttribute('aria-current');
      }
    });
    syncCaption(gallery, activeIndex);
  }

  function dispatchSlideChanged(gallery, slide) {
    const viewer = getViewer(gallery);
    if (!viewer || !slide) return;

    viewer.dispatchEvent(
      new CustomEvent('slideChanged', {
        detail: { currentElement: slide },
      })
    );
  }

  function destroyGallery(gallery) {
    if (gallery.mainSwiper) {
      gallery.mainSwiper.destroy(true, true);
      gallery.mainSwiper = null;
    }
    gallery.thumbsSwiper = null;
  }

  function prepareSlides(mainEl) {
    mainEl.querySelectorAll('.swiper-slide').forEach((slide) => {
      slide.classList.add('is-active');
      slide.style.removeProperty('display');
    });
  }

  function initGallery(gallery) {
    if (typeof Swiper === 'undefined') return;

    destroyGallery(gallery);

    const mainEl = gallery.querySelector('.yamaga-product-gallery__main');
    if (!mainEl) return;

    const stageEl = gallery.querySelector('.yamaga-product-gallery__main-stage');
    if (stageEl) {
      stageEl.style.width = '100%';
      stageEl.style.maxWidth = '100%';
    }
    mainEl.style.width = '100%';
    mainEl.style.maxWidth = '100%';

    const slides = mainEl.querySelectorAll('.swiper-slide');
    if (slides.length <= 1) return;

    slides.forEach((slide) => {
      slide.style.removeProperty('width');
    });

    prepareSlides(mainEl);

    const prevEl = gallery.querySelector('.yamaga-product-gallery__nav--prev');
    const nextEl = gallery.querySelector('.yamaga-product-gallery__nav--next');

    const mainSwiper = new Swiper(mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 350,
      threshold: 8,
      longSwipesRatio: 0.15,
      resistanceRatio: 0.85,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      navigation: {
        prevEl,
        nextEl,
      },
      on: {
        slideChange(swiper) {
          syncActiveClasses(gallery, swiper.activeIndex);
          dispatchSlideChanged(gallery, swiper.slides[swiper.activeIndex]);
        },
        afterInit(swiper) {
          syncActiveClasses(gallery, swiper.activeIndex);
        },
      },
    });

    gallery.mainSwiper = mainSwiper;

    const updateSwiper = () => {
      prepareSlides(mainEl);
      mainSwiper.updateSize();
      mainSwiper.updateSlides();
      mainSwiper.update();
    };

    requestAnimationFrame(updateSwiper);
    window.addEventListener('load', updateSwiper, { once: true });

    const activeIndex = Array.from(slides).findIndex((slide) =>
      slide.classList.contains('yamaga-product-gallery__slide--current')
    );
    const startIndex =
      activeIndex >= 0
        ? activeIndex
        : Array.from(slides).findIndex((slide) => slide.classList.contains('is-active'));

    if (startIndex > 0) {
      mainSwiper.slideTo(startIndex, 0, false);
    }
    syncActiveClasses(gallery, startIndex >= 0 ? startIndex : 0);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(initGallery);
  }

  function destroyAll(scope) {
    (scope || document).querySelectorAll(ROOT_SELECTOR).forEach(destroyGallery);
  }

  function onReady() {
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  window.addEventListener('load', onReady);

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroyAll(event.target);
  });

  document.addEventListener('yamaga:product-gallery:refresh', (event) => {
    initAll(event.target);
  });
})();
